import { Aggreg8Account } from '../Model/Aggreg8Account';
import { Aggreg8Bank } from '../Model/Aggreg8Bank';
import { UserFlowInitResponse, UserFlowInitRequest, UserFlowStateResponse } from '../Model/UserFlow';
import { storeApi } from './storeApi';

export const aggreg8Api = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    postUserFlowInit: builder.query<UserFlowInitResponse, UserFlowInitRequest>({
      query: ({ flowType, accountId }) => {
        return {
          url: '/aggreg8/user-flow/init',
          body: { flow_type: flowType, account_id: accountId },
          method: 'POST',
        };
      },
    }),
    getUserFlowState: builder.query<UserFlowStateResponse, { url: string }>({
      query({ url }) {
        return {
          url: url,
          method: 'GET',
        };
      },
    }),
    getAccounts: builder.query<Aggreg8Account[], void>({
      query: () => ({
        url: `/aggreg8/accounts`,
        method: 'GET',
      }),
    }),
    getBanks: builder.query<Aggreg8Bank[], void>({
      query: () => ({
        url: '/aggreg8/banks',
        method: 'GET',
      }),
    }),
    pullImmediatelyAggreg8Data: builder.mutation<void, void>({
      query: () => ({
        url: '/aggreg8/pull',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLazyGetUserFlowStateQuery,
  useLazyGetAccountsQuery,
  useLazyGetBanksQuery,
  usePullImmediatelyAggreg8DataMutation,
  useLazyPostUserFlowInitQuery,
} = aggreg8Api;
